module.exports = __webpack_public_path__ + "img/quanzhouyinhang.b28ac1a8.jpg";